export default "__VITE_ASSET__eMrP_wK3__"